// ------------------------------------
// props 輸入需求 : 
// props.setNavIndex : function( params : str )        ( 回傳 : str (回傳選到的分頁名稱) )
// ------------------------------------

import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import ConfigHandler from '../../actions/ConfigHandler'
import { SET_PAGE } from '../../stores/reducer_HistoryPage'
import { SET_ADDPAGE, SET_LAYOUTPAGE } from '../../stores/reducer_LayoutPage'

export const NavBarTabMobile =(props)=>{
    const dispatch = useDispatch()
    const {t} = useTranslation()
    const LayoutPage = useSelector(state=>state.store_layout)
    let _div = ConfigHandler.layoutControl().layoutArr.map((res, index)=><div key={res[1]} className={`fx-d-c fx-ccc navTab-option ${(LayoutPage.pageActive[index]) ? 'activate' : ''} ${res[2] ? '' : 'd-none'}`} 
        onClick={()=>{
            dispatch(SET_LAYOUTPAGE(index))
            dispatch(SET_ADDPAGE(index))
        }}>
        <img src={res[0]} className="pic" alt={res[1]} />
        <div id="Dashboard">{t(res[1])}</div>
    </div>)
    return(
    <div className={`navTab ${props.show? 'showTab':''}`}>
        {_div}
    </div>
    );
}

export const HisBarTabMobile =(props)=>{
    const dispatch = useDispatch()
    const {t} = useTranslation()
    const HisPage = useSelector(state=>state.store_hisPage)
    const hisRec = ConfigHandler.hisRecControl()
    const pageNum = hisRec.pageNum
    let _div = hisRec.layoutName.map((res, index)=><div key={res} className={`fx-d-c fx-ccc navTab-option ${(HisPage.pageActive[index]) ? 'activate' : ''} ${res[2] ? '' : 'd-none'}`} 
        onClick={()=>{dispatch(SET_PAGE(index))}}>
        <img src={hisRec.layoutImg[index]} className="pic" alt={hisRec.layoutName[index]} />
        <div id="Dashboard" className='fontHis'>{t(res)}</div>
    </div>)
    return(
    <div className={`HisNavTab ${props.show? 'closeTab':''} _${pageNum}`}>
        {_div}
    </div>
    );
}